import { MrzScannerResult, MrzScannerUiResult, handleImageInput, mapRTUUIResult, withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotMrzImpl = {
    async scanFromImage(params) {
        return withSBErrorHandling(async () => new MrzScannerResult(await ScanbotSDKPlugin.scanMrzFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
        })));
    },
    async startScanner(configuration) {
        return withSBErrorHandling(async () => mapRTUUIResult(await ScanbotSDKPlugin.startMrzScanner(configuration), MrzScannerUiResult));
    },
    async forceCloseScanner() {
        return withSBErrorHandling(ScanbotSDKPlugin.forceCloseMrzScanner);
    },
};
//# sourceMappingURL=MrzScannerImpl.js.map